import React from 'react';
import FontAwesomeIcon from '../Icon';
import './EmptyAvatar.scss';

const EmptyAvatar = () => (
  <div className="empty-avatar" aria-hidden="true">
    <FontAwesomeIcon glyph="user-slash" weight="light" />
  </div>
);

export default EmptyAvatar;
